/* 🤖 this file was generated by svg-to-ts */
export const iconMkr: {
  name: 'mkr';
  data: string;
} = {
  name: 'mkr',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#maker__clip0_298_619)"><path fill="#58B89C" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" d="M7.84 22.49H6v-14l9.71 7.03v6.97h-1.84v-6.08l-6.03-4.37zm10.29-6.07v6.08h-1.84v-6.97L26 8.5v14h-1.84V12.06l-6.03 4.37z"/></g><defs><clipPath id="maker__clip0_298_619"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
